import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import IssuesPreview from "@/components/IssuesPreview";
import CallToAction from "@/components/CallToAction";
import candidatePhoto from "@/assets/candidate-photo.jpg";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Matt Bucher for State Representative | 33rd District</title>
        <meta
          name="description"
          content="Matt Bucher is running for State Representative in the 33rd District. A proven conservative leader standing up for rural communities."
        />
        <link rel="canonical" href="https://votebucher.com/" />
        <meta property="og:url" content="https://votebucher.com/" />
      </Helmet>

      <div className="min-h-screen flex flex-col">
        <Header />

        <main id="main-content" className="flex-grow">
          <HeroSection />

          {/* About Preview */}
          <section className="py-20 bg-background" aria-labelledby="about-preview-heading">
            <div className="container mx-auto px-4">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <div className="lg:hidden">
                  <img
                    src={candidatePhoto}
                    alt="Matt Bucher speaking at a community event"
                    className="rounded-lg shadow-xl max-h-[400px] mx-auto object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h2 id="about-preview-heading" className="font-display text-4xl md:text-5xl font-bold text-foreground mb-6">
                    A Fighter for the 33rd District
                  </h2>
                  <p className="font-body text-lg text-muted-foreground mb-6">
                    Matt Bucher is the Republican candidate for Delaware's 33rd District House seat. As Vice President
                    of the Milford School Board, Legislative Chair of the Delaware School Boards Association, founder of
                    Milford School District’s first and only charitable academic foundation, and three-term Chairman of
                    the 33rd District Republican Party, he combines extensive professional experience with over two
                    decades of public service and volunteerism.
                  </p>
                  <p className="font-body text-lg text-muted-foreground mb-8">
                    Matt is running to fight for rural and small-town interests against a state government that doesn't
                    always have us in mind—defending local control, constitutional rights, and the values that make our
                    communities strong.
                  </p>
                  <Button variant="navy" size="lg" asChild>
                    <Link to="/about">Learn More About Matt</Link>
                  </Button>
                </div>
                <div className="hidden lg:block">
                  <img
                    src={candidatePhoto}
                    alt="Matt Bucher speaking at a community event"
                    className="rounded-lg shadow-xl max-h-[450px] object-cover ml-auto"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </section>

          <IssuesPreview />
          <CallToAction />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Index;
